export default
{
	icons: [
		{
			name: "blinds",
			x: 1152,
			y: 315
		},
		{
			name: "clock",
			x: 1612,
			y: 91.25
		},
		{
			name: "whiteboard",
			x: 1728,
			y: 453.05
		},
		{
			name: "drip",
			x: 710.95,
			y: 328.9
		},
		{
			name: "breakfast",
			x: 399,
			y: 553.05
		},
		{
			name: "talk2pat",
			x: 515,
			y: 404.05
		},
		{
			name: "exit",
			x: 968,
			y: 960.05
		},
		{
			name: "zweedseBand",
			x: 652,
			y: 550.05
		},
		{
			name: "glasses",
			x: 315,
			y: 562.05
		},
		{
			name: "medication",
			x: 612,
			y: 444.5
		},
		{
			name: "water",
			x: 334.5,
			y: 517.55
		},
		{
			name: "cad",
			x: 560.95,
			y: 741
		},
		{
			name: "shower",
			x: 834,
			y: 568
		}
	],
	objects: [
		{
			name: "clock",
			x: 1575.6,
			y: 0
		},
		{
			name: "whiteboard",
			x: 1546,
			y: 539.4
		}
	]
}